
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/revinu",
      function () {
        return require("private-next-pages/products/revinu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/revinu"])
      });
    }
  